export const API_URL = 'https://api.sticket.app' // PROD DOMINIO
//export const API_URL = 'https://sticket-api-sjzgaswksq-ew.a.run.app' // PROD
//export const API_URL = 'https://sticket-api-dev-sjzgaswksq-ew.a.run.app' // DEV
//export const API_URL = 'http://localhost:8080'